<template>
  <div>
    <ValidationObserver ref="observer2" v-slot="{ valid }" @submit.prevent="valid(handleSubmit)">
      <!-- <form @submit.prevent="passes(nextCard)"> -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>outlined_flag</md-icon>
          </div>
          <h4 class="title">Enter SafeCore Jobsite Information</h4>
        </md-card-header>
        <md-card-content class="md-layout start-inputs">
          <md-progress-bar class="md-primary md-layout-item md-size-100" :md-value="card2amt"></md-progress-bar>
          <md-autocomplete class="search md-layout-item md-size-45 ats-select md-medium-size-100 md-small-size-100"
            v-model="selectedProject" :md-options="projectNames.map(project => project.job_name)"
            :md-open-on-focus="false" @md-selected="handleProjectSelected">
            <label>Search by project name or job number...</label>
          </md-autocomplete>
          <ValidationProvider name="jobname" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Job Name</label>
              <md-input v-model="request.job_name" type="text" required></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>

          <md-field class="md-layout-item md-size-100" v-if='company.company_type == "facility"'>
            <label>Select Facility</label>
            <md-select v-model="request.facility_id" name="facility_id" id="facility_id" required
              @change="onFacilityChange">
              <md-option v-for="facility in facilities" :key="facility.id" :value="facility.id" v>{{ facility.name }}
              </md-option>
            </md-select>
          </md-field>
          <!-- <md-field class="md-layout-item md-size-45 ats-select md-medium-size-100 md-small-size-100">
            <label>Choose from an existing project</label>
            <md-select v-model="existingproject" name="existingproject" id="existingproject">
              <md-option v-for="(p, index) in projects" :value="index" :key="index">{{p.job_name}}</md-option>
            </md-select>
          </md-field> -->

          <AutoCompleteInput v-on:childToParent="onChildClick" v-bind:existingaddress="existingaddress" />
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <label>Address Line 2</label>
            <md-input v-model="request.address_attributes.second_street_address" autocomplete="off"
              type="text"></md-input>
          </md-field>
          <ValidationProvider name="city" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>City</label>
              <md-input v-model="request.address_attributes.city" type="text" required autocomplete="off"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider name="state" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>State</label>
              <md-input v-model="request.address_attributes.state" type="text" required autocomplete="off"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider name="zip_code" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Zip Code</label>
              <md-input v-model="request.address_attributes.zip_code" type="text" required
                autocomplete="off"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <label>PO#</label>
            <md-input v-model="request.purchase_order_number" type="text"></md-input>
          </md-field>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <label>JOB#</label>
            <md-input v-model="request.job_number" type="text"></md-input>
          </md-field>
          <div class="disabled-fields md-layout get-space">
            <md-field class="md-layout-item md-size-100">
              <label>Company Name</label>
              <md-input v-model="request.company.company_name" type="text"></md-input>
            </md-field>
            <md-field class="md-layout-item md-size-100">
              <label>Street Address</label>
              <md-input v-model="request.company.address.street_address" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>Address Line 2</label>
              <md-input v-model="request.company.address.second_street_address" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>City</label>
              <md-input v-model="request.company.address.city" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>State</label>
              <md-input v-model="request.company.address.state" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>Zip Code</label>
              <md-input v-model="request.company.address.zip_code" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-100">
              <label>Office Phone</label>
              <md-input v-model="request.company.office_phone" type="text"></md-input>

            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>GPR First Name & Last Name</label>
              <md-input v-model="fullName" type="text"></md-input>
            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>Cell Phone</label>
              <md-input v-model="request.user.phone_number" type="text"></md-input>
            </md-field>
            <md-field class="md-layout-item md-size-40 md-medium-size-100 md-small-size-100">
              <label>Email Address</label>
              <md-input v-model="request.user.email" type="text"></md-input>
            </md-field>
          </div>
          <!-- <md-checkbox v-model="matchContact" class="md-layout-item md-size-100" @change="checkMatch">
            Site Contact same as main contact?
          </md-checkbox> -->
          <!-- <ValidationProvider name="sitecontactfname" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100">
            <md-field  :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Site Contact First & Last Name</label>
              <md-input v-model="contactFullName" type="text" required></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider> -->
          <div class="md-layout-item md-size-100"></div>
          <ValidationProvider name="sitecontactfname" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Site Contact First Name</label>
              <md-input v-model="request.site_contact_attributes.first_name" type="text"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider name="sitecontactlname" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Site Contact Last Name</label>
              <md-input v-model="request.site_contact_attributes.last_name" type="text"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider name="sitecontactphone" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Cell Phone</label>
              <md-input v-model="request.site_contact_attributes.phone_number" type="text"></md-input>
              <span class="md-helper-text">
                Please enter your phone number without dashes or parenthesis
              </span>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider name="sitecontactemail" rules="email" v-slot="{ passed, failed }"
            class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Email Address</label>
              <md-input v-model="request.site_contact_attributes.email" type="text"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <p v-if="notValid" class="required-fields">Please fill in required fields</p>
          <md-progress-spinner v-if="isLoading == true" md-mode="indeterminate" class="md-accent ats-spin"
            :md-diameter="30" :md-stroke="3"></md-progress-spinner>
          <md-button class="md-info" v-on:click="prevCard()">Previous</md-button>
          <p v-if="locationHasErrors" class='error-notes'>
            There was a problem - please try and save it again.
          </p>
          <!-- <md-button class="md-info" v-on:click="nextCard()">Next</md-button> -->
          <md-button class="md-success start-ats-p" v-on:click="handleSubmit()">Request SafeCore-ATS/Start
            Project</md-button>
        </md-card-actions>
      </md-card>
      <!-- </form> -->
    </ValidationObserver>
  </div>
</template>
<script>

import AutoCompleteInput from '@/pages/Dashboard/ProjectPages/Components/AutoCompleteInput.vue';
import { extend } from "vee-validate";
import { required, email, digits } from "vee-validate/dist/rules";
import axios from 'axios';
extend("email", email);
extend("required", required);
extend("digits", digits);
// console.log('here' ,this.projects)
export default {
  props: ['request', 'projects', 'existingaddress'],
  components: {
    AutoCompleteInput
  },
  data() {
    return {
      card2amt: 40,
      matchContact: true,
      notValid: false,
      projectNames: [],
      selectedProject: '',
      searchProjects: {},
      clickedOnce: false,
      isLoading: false,
      locationHasErrors: false,
      company_name: '',
      facilities: [],
      companyAddress: {
        street_address: '',
        address_line_2: '',
        city: '',
        state: '',
        zip_code: ''
      },
      company: {},
      // exAddress: '',
    }
  },
  mounted() {
    console.log('company', this.$store.state.company)
    this.company = this.$store.state.company;
    if (this.company) {
      this.company_name = this.company.company_name;
      const companyId = this.company.id;
      api.getCompanyDataAdmin(companyId).then((response) => {
        this.facilities = response.data.facilities;
      });
    }
  },
  methods: {
    autoFill(project){
      if (project != undefined && project.address != undefined) {
        this.request.address_attributes = project.address;
        this.request.job_name = project.job_name;
        this.request.site_contact_attributes = project.site_contact;
        // this.existingaddress = project.address.street_address;
        // console.log('here')
        this.$emit("getAddress", project.address.street_address);
      } else {
        this.request.address_attributes = {
          street_address: '',
          address_line_2: '',
          city: '',
          state: '',
          zip_code: ''
        };
        this.request.job_name = '';
        this.request.site_contact_attributes = {
          first_name: '',
          last_name: '',
          email: '',
          phone_number: ''
        };
        this.existingaddress = '';
      }
    },
    prevCard() {
      this.$emit("prev", 2);
    },
    async handleSubmit() {
      this.clickedOnce = true;
      this.isLoading = true;
      const isValid = await this.$refs.observer2.validate();
      if (isValid) {
        console.log('valid')
        this.notValid = false;
        try {
          this.$emit("submit");
        } catch (error) {
          this.locationHasErrors = true;
          this.isLoading = false;
        }
      } else {
        console.log('not valid')
        this.isLoading = false;
        this.notValid = true;
        this.clickedOnce = false;
      }
    },
    async nextCard() {
      const isValid = await this.$refs.observer2.validate();
      if (isValid) {
        this.notValid = false;
        this.$emit("next", 2);
      } else {
        this.notValid = true;
      }
    },
    onChildClick (value) {
      this.request.address_attributes.street_address = value[0].long_name + ' ' + value[1].long_name;
      this.request.address_attributes.city = value[3].long_name;
      this.request.address_attributes.state = value[5].long_name;
      this.request.address_attributes.zip_code = value[7].long_name;
      var sa = value[0].long_name + ' ' + value[1].long_name;
      // this.existingaddress = sa;
      this.$emit("getAddress", sa);
    },
    checkMatch() {
      if (this.matchContact) {
        this.request.site_contact_attributes = Object.assign({}, this.request.user)
      } else {
        Object.keys(this.request.site_contact_attributes).forEach(k => {
          this.request.site_contact_attributes[k] = '';
        })
      }
    },
     handleProjectSelected(selectedProjectName) {
      if (selectedProjectName) {
        // Find the selected project object by name
        const selectedProject = this.projectNames.find(project => project.job_name === selectedProjectName);
        if (selectedProject) {
          this.autoFill(selectedProject);
        }
      }
    },
    onFacilityChange(event) {
      console.log('Selected Facility ID:', this.request.facility_id);
      const facility = this.facilities.find(facility => facility.id === this.request.facility_id);
      console.log('Selected Facility:', facility.address);
      this.request.address_attributes = facility.address
      this.$emit("getAddress", facility.address.street_address);
      this.request.job_name = 'Facility:' + facility.name
      // You can perform additional actions here when a facility is selected
    }
  },
  watch: {
    selectedProject: function(){
      this.projectNames = this.projects
    },
    'request.facility_id'(newValue) {
      this.onFacilityChange(newValue);
    }
  },
  computed: {
    fullName() {
      return `${this.request.user.first_name} ${this.request.user.last_name}`;
    },
    contactFullName() {
      return `${this.request.site_contact_attributes.first_name} ${this.request.site_contact_attributes.last_name}`;
    }
  },
}
</script>
<style lang="scss">

</style>
